export default __webpack_public_path__ + "static/media/ded.64ade0fa.png";